import type { ChangeEvent, MouseEvent } from "react";
import { noop } from "lodash";
import { H6, RadioButton } from "orcs-design-system";
import {
  positionFieldFilterItems,
  positionOccupancyStatusFilterOptions,
} from "../../../pages/SearchPage/SearchPage.config";
import FilterSearchSection from "./FilterSearchSection";

type PositionStatusFilterProps = {
  positionStatus: string | undefined;
  onSelectStatus: (status: string) => (e: MouseEvent) => void;
  positionFilters: string[];
  onPositionFieldChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const PositionStatusFilter = ({
  positionStatus,
  onSelectStatus,
  positionFilters,
  onPositionFieldChange,
}: PositionStatusFilterProps) => (
  <>
    <H6 fontWeight="bold" mt="s">
      Filter by status:
    </H6>
    {positionOccupancyStatusFilterOptions.map(({ value, label }) => (
      <RadioButton
        key={value}
        name="position-status-filter"
        label={label}
        checked={positionStatus === value}
        onChange={noop}
        onClick={onSelectStatus(value)}
      />
    ))}
    <FilterSearchSection
      items={positionFieldFilterItems}
      onChange={onPositionFieldChange}
      checkedItems={positionFilters}
    />
  </>
);

export default PositionStatusFilter;
